/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Select_Group_Members_PromptInputs */

const en_team_manager_select_group_members_prompt = /** @type {(inputs: Team_Manager_Select_Group_Members_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Select a group to manage members`)
};

const fr_team_manager_select_group_members_prompt = /** @type {(inputs: Team_Manager_Select_Group_Members_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sélectionnez un groupe pour gérer les membres`)
};

const de_team_manager_select_group_members_prompt = /** @type {(inputs: Team_Manager_Select_Group_Members_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wählen Sie eine Gruppe aus, deren Mitglieder Sie verwalten möchten.`)
};

const it_team_manager_select_group_members_prompt = /** @type {(inputs: Team_Manager_Select_Group_Members_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleziona un gruppo per gestire i membri`)
};

const ru_team_manager_select_group_members_prompt = /** @type {(inputs: Team_Manager_Select_Group_Members_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите группу для управления ее участниками.`)
};

const es_team_manager_select_group_members_prompt = /** @type {(inputs: Team_Manager_Select_Group_Members_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seleccione un grupo para administrar a los miembros`)
};

const zh_cn2_team_manager_select_group_members_prompt = /** @type {(inputs: Team_Manager_Select_Group_Members_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个组来管理成员`)
};

const ja_team_manager_select_group_members_prompt = /** @type {(inputs: Team_Manager_Select_Group_Members_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メンバーを管理するグループを選択してください`)
};

const hi_team_manager_select_group_members_prompt = /** @type {(inputs: Team_Manager_Select_Group_Members_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सदस्यों को प्रबंधित करने के लिए एक समूह चुनें`)
};

const pt_pt2_team_manager_select_group_members_prompt = /** @type {(inputs: Team_Manager_Select_Group_Members_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selecione um grupo para gerenciar os membros.`)
};

/**
* | output |
* | --- |
* | "Select a group to manage members" |
*
* @param {Team_Manager_Select_Group_Members_PromptInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_select_group_members_prompt = /** @type {((inputs?: Team_Manager_Select_Group_Members_PromptInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Select_Group_Members_PromptInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_select_group_members_prompt(inputs)
	if (locale === "de") return de_team_manager_select_group_members_prompt(inputs)
	if (locale === "it") return it_team_manager_select_group_members_prompt(inputs)
	if (locale === "ru") return ru_team_manager_select_group_members_prompt(inputs)
	if (locale === "es") return es_team_manager_select_group_members_prompt(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_select_group_members_prompt(inputs)
	if (locale === "ja") return ja_team_manager_select_group_members_prompt(inputs)
	if (locale === "hi") return hi_team_manager_select_group_members_prompt(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_select_group_members_prompt(inputs)
	return en_team_manager_select_group_members_prompt(inputs)
});